import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { storeFilterActions } from '../../../redux/modules/Actions';
import { AppState } from '../../../redux/modules/store';
import StoreFilterEmployee from '.';
import { sortAgencies } from '../../../redux/operations/StoreFilterList';
import { FilterItem } from '../../../redux/reducers/StoreFilterReducer';
import { getErrorMessageHeight } from '../StoreFilterAgency/functions';
import { getClientErrorMsg, LIMIT_FILTER_ITEMS } from '../../../utils/CustomHooks/useValidateFilter';

const mapStateToProps = (appState: AppState) => {
  const filterStore = appState.filterStore;
  const { prohibitedWordMstList } = appState.masterInfo;
  const defaultFilter: FilterItem = {
    filterID: '',
    filterName: '',
    ordcstmCdList: [],
    isActive: true,
    checked: false,
    sortOrder: 0,
    isExist: true,
  };
  const active = filterStore.data.findIndex((item) => item.isActive === true);
  const itemActive: FilterItem = active !== -1 ? filterStore.data[active] : defaultFilter;
  const isLimitFilterItem = LIMIT_FILTER_ITEMS === filterStore.cloneData.length && 'filterUuid' in itemActive;
  const clientErrorMsg = getClientErrorMsg({
    itemActive,
    cloneData: filterStore.cloneData,
    prohibitedWordMstList,
    isLimitFilterItem,
  });

  return {
    stores: sortAgencies(appState.storeSelector.originalAgencies),
    filterStore: filterStore,
    itemActive,
    errorMessageHeight: getErrorMessageHeight(!!clientErrorMsg, !!itemActive?.isExist, filterStore.msg.length),
    groupAgencies: appState.storeSelector.groupAgencies || {},
    originalAgencies: appState.storeSelector.originalAgencies || {},
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateDraftStore: (itemActive: FilterItem) => {
      dispatch(storeFilterActions.draftFilter.update(itemActive));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreFilterEmployee);
